import React from 'react';
import { Alert, styled } from '@mui/material';

const StyledAlert = styled(Alert)(({ theme }) => ({
  marginTop: theme.spacing(3),
}));

export const DuplicateInvestorAlert: React.FC<{ message: string }> = ({
  message,
}) => {
  return <StyledAlert severity="warning">{message}</StyledAlert>;
};
